import { apiClient } from "@/services/services";
import type { Category } from "@/types/category";
import type { FilterItem } from "@/types/filterItem";
import type { Submitted } from "@/types/submitted";
import type { AxiosResponse } from "axios";
import type { ResultItem } from "@/types/resultItem";
import { submitTypePrice } from "@/globalConsts/submitTypes";
import { submitTypeTravelNumber } from "@/globalConsts/submitTypes";

// v2: get search results without "maxResultCountExceeded = true" (v1: maxResult limit = 2000)
const version = 2;

export async function fetchResults(
  apiEndpoint: string,
  submitted: Submitted,
  categories: Category[],
  pageSize: number,
  countryTags: []
) {
  try {
    const response: AxiosResponse = await apiClient.post(apiEndpoint, {
      ...submitted,
      version,
      pageSize,
    });
    const results: ResultItem[] = response.data.items;
    const filterCategories: Category[] = [];

    if (
      response.data.filter.tags !== null &&
      Object.keys(response.data.filter.tags).length > 0
    ) {
      const combinedTags = {
        ...response.data.filter.tags,
        ...countryTags,
      };

      categories.forEach((categoryGroup: Category) => {
        filterCategories.push({
          uid: categoryGroup.uid,
          submitType: categoryGroup.submitType,
          categories: [],
        });

        categoryGroup.categories.forEach((categoryItem: FilterItem) => {
          if (
            combinedTags[categoryItem.uid] ||
            categoryItem.uid === submitTypePrice ||
            categoryItem.uid === submitTypeTravelNumber
          ) {
            const categoryGroupIndex = filterCategories.findIndex(
              (filterItem) => filterItem.uid === categoryGroup.uid
            );
            filterCategories[categoryGroupIndex].categories.push(categoryItem);
          }
        });
      });
    }
    return <
      {
        resultItems: ResultItem[];
        filter: Category[];
        total: number;
        maxResultCountExceeded: boolean;
      }
    >{
      resultItems: results,
      filter: filterCategories,
      total: response.data.total,
      maxResultCountExceeded: response.data.maxResultCountExceeded,
    };
  } catch (e) {
    if (e instanceof Error) {
      console.error("results " + e.message);
    }
  }
}
